// components/ChatBox.js
import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const ChatBox = () => {
  const whatsappNumber = '9643751779'; // ✅ add country code
  const message = encodeURIComponent('Hi Team, I am interested in a holiday package.');

  const handleWhatsAppChat = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };
  return (
    <Box
      sx={{
        backgroundImage: `url("https://images.unsplash.com/photo-1592890288564-76628a30a657?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8cGVyc29uJTIwb24lMjBwaG9uZXxlbnwwfHwwfHx8MA%3D%3D")`, // ✅ Replace with your own image
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        padding: {xs:2, md:5, lg:5},
        borderRadius: {xs:5, md:25, lg:25},
        maxWidth: "70%",
        margin: '30px auto',
        textAlign: 'start',
        boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
        position: 'relative',
        overflow: 'hidden',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        transformOrigin: 'center',
        '&:hover': {
          transform: 'scale(1.03) translateY(-6px)',
          boxShadow: 6,
        },
      }}
    >
      <Typography color='black' variant="h5" fontWeight="bold" gutterBottom>
        Planning your Next Vacation?
      </Typography>
      <Typography  color='black' variant="body1" gutterBottom>
        Dial <strong>9643751779</strong> or
      </Typography>
      <Button
        variant="contained"
        onClick={handleWhatsAppChat}
        sx={{
          borderRadius: '30px',
          marginTop: 2,
          backgroundColor: '#25D366', // WhatsApp green
          color: '#fff',
          fontWeight: 600,
          '&:hover': {
            backgroundColor: '#1ebd5a',
          },
        }}
      >
        Chat Now
      </Button>
    </Box>
  );
};

export default ChatBox;
